import { Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import ScrollToTop from './components/ScrollToTop';
import Header from './components/Header';
import Footer from './components/Footer';
import FloatingCTA from './components/FloatingCTA';

import HomePage from './pages/HomePage';
import GoldPage from './pages/GoldPage';
import WorkshopPage from './pages/WorkshopPage';
import CustomJewelryPage from './pages/CustomJewelryPage';
import WatchRepairPage from './pages/WatchRepairPage';
import BrandsPage from './pages/BrandsPage';
import AboutPage from './pages/AboutPage';
import InspirationPage from './pages/InspirationPage';
import ContactPage from './pages/ContactPage';
import ForbiddenPage from './pages/ForbiddenPage';
import NotFoundPage from './pages/NotFoundPage';

export default function App() {
  return (
    <HelmetProvider>
      <ScrollToTop />
      <div className="min-h-screen flex flex-col bg-[#FAF8F5] text-[#1A1714] font-sans antialiased selection:bg-[#D4AF37]/20 selection:text-[#1A1714] w-full max-w-full overflow-x-hidden">
        <Header />
        <main className="flex-grow w-full max-w-full overflow-x-hidden">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/vi-koeber-guld-og-soelv" element={<GoldPage />} />
            <Route path="/guldsmedevaerksted" element={<WorkshopPage />} />
            <Route path="/smykker-eget-design" element={<CustomJewelryPage />} />
            <Route path="/urereparation" element={<WatchRepairPage />} />
            <Route path="/brands" element={<BrandsPage />} />
            <Route path="/om-os" element={<AboutPage />} />
            <Route path="/inspration" element={<InspirationPage />} />
            <Route path="/inspiration" element={<InspirationPage />} />
            <Route path="/kontakt" element={<ContactPage />} />
            <Route path="/403" element={<ForbiddenPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </main>
        <Footer />
        <FloatingCTA />
      </div>
    </HelmetProvider>
  );
}
